import React, { useState } from 'react';
import { usePWAInstallPrompt } from '../pwa/usePWAInstallPrompt';

export function PWAInstallBanner() {
  const { isInstallable, triggerInstall } = usePWAInstallPrompt();
  const [dismissed, setDismissed] = useState(false);

  if (!isInstallable || dismissed) return null;

  return (
    <div style={styles.banner}>
      <span style={styles.icon}>📱</span>
      <span style={styles.text}>Install DB Preorder Scout for offline access</span>
      <button style={styles.installBtn} onClick={triggerInstall}>
        Install
      </button>
      <button style={styles.dismissBtn} onClick={() => setDismissed(true)} aria-label="Dismiss">
        ✕
      </button>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  banner: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '10px 20px',
    background: '#f97316',
    color: '#fff',
    fontSize: '14px',
    fontWeight: 500,
  },
  icon: { fontSize: '18px' },
  text: { flex: 1 },
  installBtn: {
    padding: '6px 14px',
    background: '#fff',
    color: '#f97316',
    border: 'none',
    borderRadius: '6px',
    fontWeight: 700,
    cursor: 'pointer',
    fontSize: '13px',
  },
  dismissBtn: {
    background: 'transparent',
    border: 'none',
    color: '#fff',
    cursor: 'pointer',
    fontSize: '16px',
    lineHeight: 1,
    padding: '0 4px',
  },
};
